import { Box, Dialog, useTheme } from '@mui/material'
import React from 'react'
import GenericDialog from '../GenericDialog/GenericDialog'
import CustomTypography from 'components/Fileds/CustomTypography'
import CustomTextField from 'components/Fileds/CustomTextFiled'
import * as Yup from 'yup';
import CustomTextArea from 'components/Fileds/CustomTextArea'


const TablesSchema = Yup.object().shape({
  table_no: Yup.string().required('Table Number is required'),
  capacity: Yup.number().required('Capacity is required'),
});

const TablesModalContainer = ({ open, onClose, initialData, onSubmit, loading }) => { 
    const isEdit = Boolean(initialData);
    const title = isEdit ? 'Edit Table' : 'Add Table';
    const theme = useTheme();

    return (
    <GenericDialog
        open={open}
        onClose={onClose}
        title={title}
        initialValues={{ 
            table_no: initialData?.table_no || '',
            capacity: initialData?.capacity || '',
            notes: initialData?.notes || null,
        }}
        validationSchema={TablesSchema}
        onSubmit={onSubmit}
        submitLabel={isEdit ? 'Update' : 'Save'}
        loading={loading}
        requiredFields={[ 'table_no', 'capacity' ]}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <>
        <Box sx={{mb:'20px'}}>
          <CustomTypography
              label="Table Name"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
          />
          <CustomTextField
            name="table_no"
            value={values.table_no}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            placeholder="Enter Table Name"
            error={touched.table_no && Boolean(errors.table_no)}
            helperText={touched.table_no && errors.table_no}
          />
        </Box>
        <Box sx={{mb:'20px'}}>
          <CustomTypography
              label="Capacity"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
          />
          <CustomTextField
            name="capacity"
            type="text"
            value={values.capacity}
            // onChange={handleChange}
            onChange={e => {
                if (/^\d*$/.test(e.target.value)) {
                    handleChange(e);
                }
            }}
            onBlur={handleBlur}
            fullWidth
            placeholder="Enter Capacity"
            error={touched.capacity && Boolean(errors.capacity)}
            helperText={touched.capacity && errors.capacity}
            inputProps={{
                step: 1,
                min: 1,
                maxLength: 3, 
                inputMode: 'numeric',
                pattern: '[0-9]*'
            }}
          />
        </Box>
        <Box>
            <Box className='d-flex align-items-center'>
                <CustomTypography
                    label="Notes"
                    sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
                />
                <CustomTypography
                    label="(Optional)"
                    sx={{ fontSize: '12px', fontWeight: 400, color: theme.palette.drawermenuitem.main, marginLeft:'5px' }}
                />
            </Box>
            <CustomTextArea
                name="notes"
                value={values.notes}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                placeholder="Enter Notes"
                error={touched.notes && Boolean(errors.notes)}
                helperText={touched.notes && errors.notes}
            />
        </Box>
        </>
      )}
    </GenericDialog>
    )
}

export default TablesModalContainer
